import { Tooltip as Tooltip$1, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
const statusColorMap = (theme) => ({
  CREDITWORTHY: theme.palette.primary[50],
  NOT_CREDITWORTHY: theme.palette.error[50],
  CHECK_IN_PROGRESS: theme.palette.secondary[50],
  EXPIRED: theme.palette.secondary[50],
  NOT_APPLICABLE_LACK_OF_DATA: theme.palette.secondary[50],
  NOT_APPLICABLE_CLINIC: theme.palette.secondary[50],
  NOT_APPLICABLE_CHILD_PATIENT: theme.palette.secondary[50],
  NOT_APPLICABLE_LACK_OF_CONSENT: theme.palette.secondary[50],
  UNKNOWN: theme.palette.grey[50]
});
const Tooltip = styled(Tooltip$1)(({ theme }) => ({
  tooltip: {
    backgroundColor: "transparent",
    fontFamily: "Lato",
    fontSize: "12px",
    lineHeight: "16px",
    letterSpacing: "0.4px",
    zIndex: 2001,
    color: "inherit"
  },
  arrow: {
    color: theme.palette.grey[800]
  }
}));
const Container = styled("div", {
  shouldForwardProp: (prop) => prop !== "status"
})(({ theme, status }) => ({
  width: 312,
  minHeight: 80,
  borderRadius: 12,
  backgroundColor: status ? statusColorMap(theme)[status] : theme.palette.grey[50],
  boxShadow: "0px 2px 4px 0px rgba(33, 33, 33, 0.16), 0px 5px 10px 0px rgba(33, 33, 33, 0.10)",
  display: "flex",
  flexDirection: "column",
  boxSizing: "border-box",
  paddingBottom: theme.spacing(1),
  borderTop: status ? `4px solid ${statusColorMap(theme)[status]}` : "none",
  color: theme.palette.grey[800]
}));
const Header = styled("div")(({ theme }) => ({
  paddingTop: theme.spacing(1.5),
  paddingRight: theme.spacing(2),
  paddingLeft: theme.spacing(2)
}));
const Footer = styled("div")(({ theme }) => ({
  paddingLeft: theme.spacing(1)
}));
const Title = styled(Typography)(() => ({
  fontFamily: "Lato",
  fontWeight: 700,
  fontSize: 14,
  lineHeight: "20px",
  letterSpacing: "0.25px"
}));
const Summary = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  paddingTop: theme.spacing(1),
  paddingRight: theme.spacing(2),
  paddingBottom: theme.spacing(1),
  paddingLeft: theme.spacing(2)
}));
const SummaryItem = styled("div")(() => ({
  display: "flex",
  justifyContent: "space-between",
  flexDirection: "row",
  marginBottom: 4,
  width: "100%"
}));
const SummaryItemKey = styled("span")(() => ({
  fontFamily: "Lato",
  fontWeight: 400,
  fontSize: 12,
  lineHeight: "16px",
  letterSpacing: "0.4px"
}));
const SummaryItemValue = styled("span")(() => ({
  fontFamily: "Lato",
  fontWeight: 700,
  fontSize: 12,
  lineHeight: "16px",
  letterSpacing: "0.4px"
}));
export {
  Container,
  Footer,
  Header,
  Summary,
  SummaryItem,
  SummaryItemKey,
  SummaryItemValue,
  Title,
  Tooltip
};
